<template>
  <!-- クライアント管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>クライアント管理</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: clientRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" nowrap>取引先企業名</th>
              <th scope="col" nowrap>取引先担当者名</th>
              <th scope="col" nowrap>電話番号</th>
              <th scope="col" nowrap>E-Mail</th>
              <th scope="col" nowrap>住所</th>
              <th scope="col" nowrap>更新者</th>
              <th scope="col" nowrap>更新日</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in client" :key="item.company_name">
              <td>
                <router-link
                  :to="{ name: clientInfo, params: { value: item } }"
                  >{{ item.company_name }}</router-link
                >
              </td>
              <td nowrap>{{ item.staff_name }}</td>
              <td nowrap>{{ item.telephone }}</td>
              <td nowrap>{{ item.email }}</td>
              <td>{{ item.address }}</td>
              <td nowrap>{{ item.updated_user }}</td>
              <td nowrap>{{ formatDate(item.updated_at) }}</td>
              <td nowrap>
                <button
                  v-on:click="openModal(item, index)"
                  class="btn btn-danger"
                >
                  削除
                </button>
                <!-- 削除モーダルコンポーネント呼出 -->
                <ClientDeleteModal
                  :draggable="true"
                  :resizable="true"
                  :val="postItem"
                  :loading="loading"
                  v-show="showModal"
                  @delete="deleteClient"
                  @close="closeModal"
                >
                </ClientDeleteModal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import ConstList from "./../ConstList";
import ClientDeleteModal from "./ClientDeleteModal";
import VPagination from "vuejs-paginate";
export default {
  name: "List",
  components: {
    ClientDeleteModal,
    VPagination,
  },
  data() {
    return {
      // 削除画面モーダル
      showModal: false,
      // 削除画面へ渡すアイテム
      postItem: "",
      // 削除用のID
      client_id: "",
      // 取得してきたクライアント情報のリスト
      client: [],
      deleted_flg: [],
      errors: [],
      clientRegister: "",
      clientInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.clientRegister = ConstList.ROUTE_CLIENT_REGISTER;
    this.clientInfo = ConstList.ROUTE_CLIENT_INFO;
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/clients/list", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.client = response.data;
            // コンソールログに一覧取得データを出力。
            if (this.client.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },

    // モーダルを表示
    openModal: function (item) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.showModal = true;
    },

    // クライアントを削除
    deleteClient: function () {
      this.loading = true;
      this.client.forEach((value, i, array) => {
        if (this.postItem.id === array[i][ConstList.ID]) {
          this.client_id = this.postItem.id;
        }
      });
      // JSON形式のパラメータ
      const params = {
        id: this.client_id,
      };
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/client/delete", params, {
          headers: {
            // content-type指定。@requestBodyでサーバ側にてバインドするため。
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          alert(ConstList.DELETE_MESSAGE);
          this.showModal = false;
          window.location.reload();
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },

    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/clients/count")
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
